import { useState } from "react";
import "./textInput.css";

const TextInput = (props) => {
  const [focused, setFocused] = useState(false);
  const {
    label = "",
    placeholder,
    optional,
    errorMessage,
    onChange,
    id,
    ...inputProps
  } = props;

  const handleFocus = (e) => {
    setFocused(true);
  };

  let type = "text";
  let step = "";
  if (label && label?.toLowerCase()?.includes("email")) type = "email";
  if (label && label === "Password") type = "password";
  if (
    (label && label?.toLowerCase()?.includes("number")) ||
    label?.toLowerCase().includes("ctc") ||
    label?.toLowerCase().includes("year") ||
    label?.includes("no") || label?.includes("mobile")) type = "number";
  if (label && label?.toLowerCase()?.includes("year")) step = "any";

  if (placeholder && placeholder?.toLowerCase().includes("amount")) type = "number"

  // if(label && label?.label?.toLowerCase()?.includes("mobile")) type="number";

  // if(label && label?.toLowerCase?.includes("mobile")) type="number"

  return (
    <div className="formInput">
      <label>{label || optional}</label>
      <input
        {...inputProps}
        type={type}
        placeholder={placeholder}
        onChange={onChange}
        // onBlur={handleFocus}
        onInvalid="true"
        className=" h-[45px]"
        onFocus={() => inputProps.name === "text" && setFocused(true)}
        focused={focused.toString()}
        step={step}
      />
      <span>{errorMessage}</span>
    </div>
  );
};

export default TextInput;
